import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Academy from './pages/Academy';
import About from './pages/About';
import ContactPage from './pages/ContactPage';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Tournament from './pages/TournamentPage';
import CompanyPage from './pages/CompanyPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/tournament" element={<Tournament />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/company/:slug" element={<CompanyPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            {/* Add a catch-all route for 404 */}
            <Route path="*" element={
              <div className="section-padding text-center">
                <Container>
                  <Row>
                    <Col lg={8} className="mx-auto">
                      <h2 className="mb-4">404 - Page Not Found</h2>
                      <p className="mb-4" style={{ color: '#666' }}>
                        The page you're looking for doesn't exist.
                      </p>
                      <Link to="/" className="btn-gold">Back to Home</Link>
                    </Col>
                  </Row>
                </Container>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;